<template>
    <div class="container-fluid">
        <h1>Changes</h1>
        <font-awesome-icon icon="sync" spin v-if="loading"/>
        <div class="alert alert-danger" role="alert" v-if="hasError">
            <b>Fehler</b><br>
            Daten konnten nicht geladen werden!
        </div>

        <div class="row">
            <div class="form-group col-3">
                <label for="startBranch">Start-Branch</label>
                <b-form-select id="startBranch" v-model="from" :options="releaseBranches"/>
            </div>
            <div class="form-group col-3">
                <label for="endBranch">End-Branch</label>
                <b-form-select id="endBranch" v-model="to" :options="releaseBranches"/>
            </div>
            <div class="form-group col-3">
                <label for="projekt">Projekt</label>
                <b-form-select id="project" v-model="project" :options="projects"/>
            </div>
        </div>

        <h4>Hinweise:</h4>
        <div class="row">
            <div class="col-12">
                <font-awesome-icon icon="sync" spin v-if="loading2"/>
                <table class="table">
                    <thead>
                    <tr>
                        <th>Ticket</th>
                        <th>Hinweis</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="notice in importantMessages">
                        <td>
                            <a target="_blank" v-bind:href="'https://redmine.etailer.de/issues/' + notice.issue">{{notice.issue}}</a>
                        </td>
                        <td class="text-danger">{{notice.value}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <h4>CriticalFiles Core:</h4>
        <div class="row">
            <div class="col-12">
                <font-awesome-icon icon="sync" spin v-if="loading2"/>
                <table class="table">
                    <thead>
                    <tr>
                        <th>Mode</th>
                        <th>File</th>
                        <th>Tickets</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="fileChange in filesCore" v-if="fileChange.isCritical">
                        <td>
                            <template v-if="fileChange.mode === 'M'">
                                MODIFIED
                            </template>
                            <template v-else-if="fileChange.mode === 'A'">
                                ADDED
                            </template>
                            <template v-else-if="fileChange.mode === 'D'">
                                DELETED
                            </template>
                            <template v-else-if="fileChange.mode === 'R'">
                                RENAMED
                            </template>
                            <template v-else-if="fileChange.mode === 'C'">
                                COPIED
                            </template>
                        </td>
                        <td>
                            {{fileChange.path}}
                        </td>
                        <td>
                            <template v-for="ticketnr in fileChange.tickets"><a v-if="ticketnr !== 0 && ticketnr !== '0'"
                                   target="_blank"
                                   v-bind:href="'https://redmine.etailer.de/issues/' + ticketnr">{{ticketnr}}</a>
                                <template v-if="ticketnr === 0 || ticketnr === '0'">{{ticketnr}},</template>
                                <template v-if="tickets[ticketnr]">({{tickets[ticketnr].projectName}}),</template>
                            </template>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <h4>Tickets:</h4>
        <div class="row">
            <div class="col-12">
                <font-awesome-icon icon="sync" spin v-if="loading2"/>
                <table class="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Titel</th>
                        <th>Projekt</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="ticketDetails in tickets">
                        <td>
                            <a target="_blank" v-bind:href="'https://redmine.etailer.de/issues/' + ticketDetails.id">{{ticketDetails.id}}</a>
                        </td>
                        <td>
                            {{ticketDetails.subject}}
                        </td>
                        <td>
                            {{ticketDetails.projectName}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
  import Api from '../Api'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

  export default {
    props: ['from', 'to', 'project'],
    name: 'project-status-page',
    components: {
      FontAwesomeIcon
    },
    watch: {
      project: function () {
        this.refreshData()
      },
      from: function () {
        this.refreshData()
      },
      to: function () {
        this.refreshData()
      }
    },
    methods: {
      refreshData () {
        this.loading2 = true
        if (this.project === null || this.from === null || this.to === null) {
          this.importantMessages = ['Bitte Start-Branch, End-Branch und Projekt auswählen!']
        } else {
          Api.getChanges(this.project, this.from, this.to).then((data) => {
            this.tickets = data.tickets
            this.importantMessages = data.notices
            this.filesCore = data.core.changedFiles
            if (data.custom.changedFiles) {
              this.filesCustom = data.custom.changedFiles
            }
            this.loading2 = false
          }).catch((err) => {
            if (err === 'FAILD') {
            } else if (err === 'UNAUTHORIZED') {
              this.$router.push('/login')
            }
          })
        }
      }
    },
    data: function () {
      return {
        importantMessages: [],
        fileChanges: [],
        // project: null,
        // from: null,
        // to: null,
        loading: false,
        loading2: false,
        hasError: false,
        projects: [],
        releaseBranches: [],
        filesCore: [],
        filesCustom: [],
        tickets: []
      }
    },
    mounted: function () {
      this.loading = true
      this.hasError = false

      let prom1 = Api.getReleaseBranches().then((branches) => {
        this.releaseBranches = branches
        this.loading = false
      }).catch((err) => {
        if (err === 'FAILD') {
          this.hasError = true
          this.loading = false
        } else if (err === 'UNAUTHORIZED') {
          this.$router.push('/login')
        }
      })

      let prom2 = Api.getProjectKeys().then((projects) => {
        this.projects = projects
        this.loading = false
      }).catch((err) => {
        if (err === 'FAILD') {
          this.hasError = true
          this.loading = false
        } else if (err === 'UNAUTHORIZED') {
          this.$router.push('/login')
        }
      })

      Promise.all([prom1, prom2]).then(
        () => {
          this.refreshData()
        }
      )
    }
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ChangeList.vue